import ReadSmore from 'read-smore';

export function readSmore() {
  const readMores = document.querySelectorAll('.js-read-smore');
  ReadSmore(readMores, { lessText: 'Свернуть', moreText: 'Подробнее' }).init();
}
